import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Card, Row, Col, Alert } from "react-bootstrap";
import loginGif from "../Assets/login-security.gif";
import "../components/Login.css";

// Static admin credentials
const STATIC_ADMIN_EMAIL = "admin@madhu.com";
const STATIC_ADMIN_PASSWORD = "admin123";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Redirect if already authenticated
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("adminAuthenticated") === "true";
    if (isAuthenticated) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    // Verify static credentials
    if (email === STATIC_ADMIN_EMAIL && password === STATIC_ADMIN_PASSWORD) {
      // Store admin authentication in localStorage
      localStorage.setItem("adminAuthenticated", "true");
      localStorage.setItem("adminEmail", email);
      
      // Dispatch custom event to notify AdminProtectedRoute
      window.dispatchEvent(new Event("adminAuthChange"));
      
      // Use setTimeout to ensure state update completes before navigation
      setTimeout(() => {
        navigate("/admin/dashboard", { replace: true });
      }, 50);
    } else {
      setError("Invalid email or password");
    }
  };

  return (
    <Container fluid className="login-page">
      <Row className="justify-content-center align-items-center g-0 login-row">
        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center login-visual order-1">
          <img src={loginGif} alt="Secure Login" className="login-gif" />
        </Col>
        <Col xs={12} md={6} className="p-4 p-md-5 order-2">
          <Card className="shadow-sm border-0 login-card">
            <Card.Body className="p-4 p-md-5">
              <h1 className="login-title mb-2">Log in!</h1>
              <p className="login-subtitle mb-4">Explore, learn, and grow with us. Enjoy a seamless and enriching journey—let's begin!</p>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleLogin}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Your email</Form.Label>
                  <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" required />
                </Form.Group>
                <Form.Group controlId="password" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required />
                </Form.Group>
                <Button type="submit" className="w-100 login-btn">Log in</Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;